<template>
  <div>
    <div class="lef">
     
       <span class="title">{{name}}</span>
      <div class="allContent">
        <div class="contentInfo" v-for="(item, index) in allList" :key="index">
          <span @click="goToDetail(item.id)">{{item.title}}</span>
        </div>
      </div>
      <div class="tips" v-if="allList.length == 0">暂无数据</div>

       <span class="title">推荐资讯</span>
      <div class="allContent">
        <div class="contentInfo" v-for="(item, index) in recommendList" :key="index">
          <span @click="goToDetail(item.id)">{{item.description}}</span>
        </div>
      </div>
      <div class="tips" v-if="recommendList.length == 0">暂无数据</div>
      <!-- <div class="list">
        <span class="container" @click="detailItem">人才缺口大 营销成本高 外贸企业转内销哪有那么容易</span>
        <span class="num">浏览次数: 53</span>
      </div>
      <div class="list">
        <span class="container">人才缺口大 营销成本高 外贸企业转内销哪有那么容易</span>
        <span class="num">浏览次数: 53</span>
      </div>
      <div class="list">
        <span class="container">人才缺口大 营销成本高 外贸企业转内销哪有那么容易</span>
        <span class="num">浏览次数: 53</span>
      </div> -->
      <div class="page">
        <el-pagination background layout="prev, pager, next" :page-size="30" hide-on-single-page :total="pagecount" @prev-text="prev" @current-change="current" ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
export default {
  props:{
    classId:{
      type:[String , Number],
      default:()=>{0}
    },
    classIds:[String , Number],
    title:String,
    search:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      page:10,
      indexs:1,
      pages:30,
      pagecount:0,
      recommendList:[],
      allList:[]
    }
  },
  computed:{
    name(){
      return this.title;
    },
  },
  watch:{
    classId(){
      this.getAllList();
    },
    classIds(){
      this.getArticle();
    },
    search(){
      this.getAllList();
    }
  },
  created(){
    this.getArticle();
    this.getAllList();
  },
  methods: {
    current(e){
      this.indexs = e;
      this.getAllList();
    },
    prev(e){
      this.indexs = e;
      this.getAllList();
    },
    // 推荐文章
    getArticle(){
       axios.post('/ajax/ArchiveJson.ashx',Qs.stringify({
         classid:this.classId,
         count:this.page,
         action:'tuijian',
         style:'',
         conlen:'20'
       })).then((res) => {
         this.recommendList = res.data;
      })
    },
    // 文章列表
    getAllList(){
      let url = encodeURI(`/ajax/App_Archive.ashx?keyword=${this.search}&class_id=${this.classId}&action=list&pageindex=${this.indexs}&pagesize=${this.pages}`)
      axios.get(url).then((res) => {
         this.allList = res.data.datalist;
         this.pagecount = Number(res.data.pagecount);
      })
    },
    goToDetail(value){
      this.$router.push({path:'/sxy/detail',query:{id:value,classId:this.classIds}})
    }
  }
}
</script>
<style scoped lang="scss">
.lef {
  display: flex;
  flex-direction: column;
  border: 1px solid #c9deec;
  border-top: 0;
  padding:10px;
  width: 817px;
  margin-bottom:20px;
  .page{
    margin-top: 20px;
  }
  .tips{
    padding:10px 0;
    text-align: center;
  }
  .title{
      display: block;
      font-weight: bold;
      margin: 10px 0;
      font-size: 14px;
    }
  .allContent{
    display: flex;
    flex-wrap: wrap;
    .contentInfo{
      width: 50%;
      display: flex;
      padding:6px 0;
      box-sizing: border-box;
      &>span{
        font-size: 14px;
        color: #0053a4;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:nth-child(odd){
          padding-right: 10px;
          box-sizing: border-box;        
        }
      }
    }
  }
  
  .list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    // position: relative;
    .container {
      font-size: 16px;
      width: 460px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
    .num {
      color: #999;
      font-size: 12px;
      // position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}
</style>